// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"337":"63bf44dd","364":"66579a1e","411":"d0666380","471":"fa2ed4c3","637":"89c5357c","930":"a6052a29","945":"579e3edd"}[chunkId] + ".js";
};